export default {
  filePhotos: [
    {
      file: 'pdf',
      image: require('@/assets/image/thumbnail_file/pdf-pdf.png'),
    },
    {
      file: 'aiff',
      image: require('@/assets/image/thumbnail_file/audio-aiff.png'),
    },
    {
      file: 'mp3',
      image: require('@/assets/image/thumbnail_file/audio-mp3.png'),
    },
    {
      file: 'wav',
      image: require('@/assets/image/thumbnail_file/audio-wav.png'),
    },
    {
      file: 'doc',
      image: require('@/assets/image/thumbnail_file/document-doc.png'),
    },
    {
      file: 'docx',
      image: require('@/assets/image/thumbnail_file/document-docx.png'),
    },
    {
      file: 'odt',
      image: require('@/assets/image/thumbnail_file/document-odt.png'),
    },
    {
      file: 'pages',
      image: require('@/assets/image/thumbnail_file/document-pages.png'),
    },
    {
      file: 'rtf',
      image: require('@/assets/image/thumbnail_file/document-rtf.png'),
    },
    {
      file: 'txt',
      image: require('@/assets/image/thumbnail_file/document-txt.png'),
    },
    {
      file: 'bmp',
      image: require('@/assets/image/thumbnail_file/image-bmp.png'),
    },
    {
      file: 'bpg',
      image: require('@/assets/image/thumbnail_file/image-bpg.png'),
    },
    {
      file: 'eps',
      image: require('@/assets/image/thumbnail_file/image-eps.png'),
    },
    {
      file: 'gif',
      image: require('@/assets/image/thumbnail_file/image-gif.png'),
    },
    {
      file: 'jpeg',
      image: require('@/assets/image/thumbnail_file/image-jpeg.png'),
    },
    {
      file: 'jpg',
      image: require('@/assets/image/thumbnail_file/image-jpg.png'),
    },
    {
      file: 'png',
      image: require('@/assets/image/thumbnail_file/image-png.png'),
    },
    {
      file: 'svg',
      image: require('@/assets/image/thumbnail_file/image-svg.png'),
    },
    {
      file: 'tiff',
      image: require('@/assets/image/thumbnail_file/image-tiff.png'),
    },
    {
      file: 'webp',
      image: require('@/assets/image/thumbnail_file/image-webp.png'),
    },
    {
      file: 'key',
      image: require('@/assets/image/thumbnail_file/presentation-key.png'),
    },
    {
      file: 'odp',
      image: require('@/assets/image/thumbnail_file/presentation-odp.png'),
    },
    {
      file: 'pps',
      image: require('@/assets/image/thumbnail_file/presentation-pps.png'),
    },
    {
      file: 'ppsx',
      image: require('@/assets/image/thumbnail_file/presentation-ppsx.png'),
    },
    {
      file: 'ppt',
      image: require('@/assets/image/thumbnail_file/presentation-ppt.png'),
    },
    {
      file: 'pptx',
      image: require('@/assets/image/thumbnail_file/presentation-pptx.png'),
    },
    {
      file: 'csv',
      image: require('@/assets/image/thumbnail_file/spreadsheet-csv.png'),
    },
    {
      file: 'numbers',
      image: require('@/assets/image/thumbnail_file/spreadsheet-numbers.png'),
    },
    {
      file: 'ods',
      image: require('@/assets/image/thumbnail_file/spreadsheet-ods.png'),
    },
    {
      file: 'tsv',
      image: require('@/assets/image/thumbnail_file/spreadsheet-tsv.png'),
    },
    {
      file: 'xls',
      image: require('@/assets/image/thumbnail_file/spreadsheet-xls.png'),
    },
    {
      file: 'xlsx',
      image: require('@/assets/image/thumbnail_file/spreadsheet-xlsx.png'),
    },
    {
      file: 'xml',
      image: require('@/assets/image/thumbnail_file/spreadsheet-xml.png'),
    },
    {
      file: 'odf',
      image: require('@/assets/image/spreadsheet.png'),
    },
    {
      file: 'mov',
      image: require('@/assets/image/thumbnail_file/video-mov.png'),
    },
    {
      file: 'mp4',
      image: require('@/assets/image/thumbnail_file/video-mp4.png'),
    },
    {
      file: 'avi',
      image: require('@/assets/image/thumbnail_file/video-avi.png'),
    },
    {
      file: 'wmv',
      image: require('@/assets/image/thumbnail_file/video-wmv.png'),
    },
  ],
};
